import JwtManager from './jwtManager';
import IUser from '../interfaces/IUser';
import ILoginRequest from '../interfaces/ILoginRequest';
import axiosInstance from '../initializers/axios';
import IUserMenu from '../interfaces/IUserMenu';
import IPermission from '../interfaces/IPermission';
import { useDispatch } from 'react-redux';
import { setPermission } from '../store/stores/user/permission.store';
import { setMenu } from '../store/stores/user/menu.store';
import { setUser } from '../store/stores/user/user.store';

export interface IUserInfo {
  user: IUser;
  token: string;
  menu: IUserMenu[]
  permissions: IPermission[]
  message?: string;
  redirectTo?: string;
  redirectEmail?: string;
}

class AuthManager {
  static get token(): string | null {
    return JwtManager.accessToken;
  }

  static async getUserFromToken(token: string): Promise<IUserInfo> {
    let userInfo: IUserInfo = null;
    try {
      const result = await axiosInstance.get(`/api/system/user/info`);
      userInfo = result?.data;
    } catch (e) {
      throw e;
    }
    return userInfo;
  }
  // const user = await AuthManager.getUserFromToken(data?.token);
  static async getTokenWithCredentials(payload: ILoginRequest): Promise<IUserInfo> {
    const { data } = await axiosInstance.post('/api/system/login', payload);
    const responseLogin: IUserInfo = {
      user: data.user,
      token: data.bearer,
      menu: data.menu,
      permissions: data.permissions,
      message: data.message,
      redirectTo: data.redirectTo,
      redirectEmail: data.redirectEmail,
    };
    if (responseLogin?.token) {
      JwtManager.setAccessToken(responseLogin.token);
    }
    return responseLogin;
  }

  static async loginWithCredentials(credentials: ILoginRequest): Promise<IUserInfo> {
    const response = await AuthManager.getTokenWithCredentials(credentials);
    return response;
  }

  static async register(user: IUser): Promise<void> {
    const { data } = await axiosInstance.post('/register', user);
    if (data?.token) {
      JwtManager.setAccessToken(data.token);
      window.location.pathname = '/';
    }
  }

  static logout() {
    JwtManager.clearToken();
  }
}

export default AuthManager;


